import { ContractorPanelVisitsFilters } from "../components/ContractorPanelVisitsFilter";
import { DEFAULT_SORT_BY, DEFAULT_SORT_ORDER } from "../constants";

export const getActiveFilterCount = (
  filters: ContractorPanelVisitsFilters,
): number => {
  return [
    filters.isTodayAndUpcoming,
    filters.status,
    filters.date,
    filters.sortBy !== undefined && filters.sortBy !== DEFAULT_SORT_BY,
    filters.sortOrder !== undefined && filters.sortOrder !== DEFAULT_SORT_ORDER,
  ].filter(Boolean).length;
};
